"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileUploadModal = void 0;
var uploadReducer = require("utils/upload/reducer");
exports.fileUploadModal = uploadReducer.create('@sok/web/fileupload');
